// John Eldhose 20190104
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Paper, Typography } from '@material-ui/core';
import { AddBox } from '@material-ui/icons';
import ReactTable from 'react-table';
import { getLMDRMAs } from '../../Api/getLMDRMAs';

class LMDRMAs extends Component {

  state = {
    loading: true,
    RMAs: [],
    covid19: false
  }
  componentWillMount() {
    getLMDRMAs()
      .then((rma) => {
        if(rma['status'] === 'true')
          this.setState({ RMAs: rma['data'], loading: false });
        else
          this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleCovid19 = () => {
    this.setState({ covid19: !this.state.covid19 });
  }

  render() {
    return (
      <div>
{/*
        <Button onClick={this.handleCovid19}>
          <Typography variant='display1' style={{ color: 'red' }}>LMD Service Coronavirus-Covid19 message</Typography>
        </Button>
        <Dialog
          fullScreen={true}
          open={this.state.covid19}
          onClose={this.handleCovid19}
        >
          <iframe title="covid19" src="https://update.carlsonsw.com/files/misc/covid19/LMD_Service2.html" height="500"></iframe>
          <DialogActions>
            <Button variant='raised' onClick={this.handleCovid19} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
*/}
        <Grid container>
          <Grid item xs={12} sm={12} md={1} lg={1} xl={1} >
          </Grid>
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10} >
          <Typography variant='display1'>
            <center><font color='#385687'>Laser Measurement RMA</font></center>
          </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
            <Typography variant='body1'>
              <Link to='lmdrmaform'>
                <AddBox color='primary' style={{ fontSize: 40 }} />
              </Link>
            </Typography>
          </Grid>
        </Grid>
        <Paper>
          <ReactTable
            columns={[
              {
                Header: 'RMA', accessor:'ixBug', width: 75,
                Cell: (row) => {
                  return (
                    <a href={'/lmdprint?' + row.value} target="_blank">
                      {row.value}
                    </a>
                  );
                }
              },
              { Header: 'RMA Description', accessor: 'sTitle' },
              { Header: 'Product', accessor: 'sArea', width: 125 },
              { Header: 'Serial', accessor: 'asseta03', width: 100 },
              { Header: 'Status', accessor: 'sStatus', width: 220 }
            ]}
            loading={this.state.loadin}
            data={this.state.RMAs}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </Paper>
      </div>
    );
  }
}

export default LMDRMAs;



// WEBPACK FOOTER //
// ./src/components/home/LMDRMAs.js